export const mapCountryOptions = (payload) => {
  const rows = Array.isArray(payload) ? payload : payload?.results || [];
  return rows
    .map((row) => {
      if (typeof row === 'string') {
        const name = row.trim();
        return name ? { id: name, name } : null;
      }
      const name = (row?.name || row?.id || '').trim();
      return name ? { id: row.id || name, name } : null;
    })
    .filter(Boolean);
};
